import React, {useEffect, useState} from 'react';
import BackServer from "../../api/BackServer";
import {MDBCard, MDBCardBody, MDBTable, MDBTableBody, MDBTableHead} from "mdb-react-ui-kit";
import {baseUrl_back} from "../../api/BaseUrl";
import {Button} from "@mui/material";
import Box from "@mui/material/Box";

const OrderDeltails = (props) => {
    const [products, setProducts] = useState([])
    const [sum, setSum] = useState([])
    var favor= JSON.parse( localStorage.getItem('cart'))
    var delivery=JSON.parse(localStorage.getItem('delivery'))
    var payMethod=JSON.parse(localStorage.getItem('payMethod'))
    var contacts= JSON.parse(localStorage.getItem('contacts'))

    const getProducts = async () => {

        await BackServer.GetCart(favor).then(u => {
            if (u) {
                // console.log(u.message.Products)
                setSum(u.message.Products.category.Cost)
                setProducts(u.message.Products.lst)

            }
        })}





    useEffect(() => {
        getProducts()
    }, [])
    return (
        <>
            <MDBCard>
                <MDBCardBody>
                    {/*<MDBCardTitle>Состав заказа:</MDBCardTitle>*/}

            <MDBTable>
                <MDBTableHead>
                    <tr>
                        <th scope='col'>№</th>
                        <th scope='col'></th>
                        <th scope='col'>арт.</th>
                        <th scope='col'>Название</th>
                        <th scope='col'>Размер</th>
                        <th scope='col'>Количество</th>
                        <th scope='col'>Цена</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
           {products.map((tovar, index) => (
               <tr>
                   <th scope='row'>{index+1}</th>
                   <td>
                       <div className='d-flex align-items-center'>
                           <img
                               src= {baseUrl_back+tovar.imageUrl}
                               style={{ width: '40px', height: '40px' }}
                               className='rounded-circle'
                           />
                       </div>

                   </td>
                   <td>{tovar.article}</td>
                   <td>{tovar.name}</td>
                   <td>{tovar.selected_Size}</td>
                   <td>{tovar.selected_Count}</td>
                   <td>{tovar.Price*tovar.selected_Count} ₽</td>
               </tr>
            ))}
                    <tr>
                        <th scope='row'></th>
                        <td></td>
                        <td></td>
                        <td>Доставка  {delivery.Type}</td>
                        <td> </td>
                        <td> </td>
                        <td>{delivery.Price} ₽</td>
                    </tr>
                    <tr>
                        <th scope='row'></th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td> </td>
                        <td>Сумма</td>
                        <td>{Number(sum)+Number(delivery.Price)} ₽</td>
                    </tr>
                </MDBTableBody>
            </MDBTable>
                    <p className={"myfontAB"}>Доставка:</p>
                  <p className={"myfontA"}>Способ доставки: {delivery.Type}</p>
                  <p className={"myfontA"}>Адрес: {delivery.Adress}</p>
                  <p className={"myfontA"}>Стоимость доставки: {delivery.Price} ₽</p>
                    <p className={"myfontAB"}>Оплата:</p>
                  <p className={"myfontA"}>Способ оплаты: {payMethod.Type}</p>
                    <p className={"myfontAB"}>Данные получателя:</p>
                  <p className={"myfontA"}>Получатель: {contacts.fname}</p>
                    <p className={"myfontA"}>Телефон получателя: {contacts.phone}</p>
                    <p className={"myfontA"}>Email получателя: {contacts.email}</p>

                </MDBCardBody>
            </MDBCard>

            <Box sx={{ mb: 2 }}>
                <div>

                    <Button
                        variant="contained"
                        onClick={props.callNext}
                        sx={{ mt: 1, mr: 1 }}
                    >
                        Оформить заказ
                    </Button>
                    <Button
                        variant="contained"
                        onClick={props.callBackX}
                        sx={{ mt: 1, mr: 1 }}
                    >
                        Назад
                    </Button>

                    <Button
                        variant="contained"
                        onClick={props.callreset}
                        sx={{ mt: 1, mr: 1 }}
                    >
                        В начало
                    </Button>

                </div>
            </Box>
        </>
    );
};

export default OrderDeltails;